<template>
	<div class="result-object">
		<h2 class="page-title"><em>Coleções</em></h2>

		<div class="search-infos">
			<p><strong>VOCÊ PESQUISOU:</strong> {{ this.$route.query.texto || '' }}</p>
			<p>Aproximadamente {{ totalDeColecoes }} resultados</p>
		</div>

		<div class="search-result">
			<div class="filters">
				<router-link :to="{ name: 'resultadoObjeto', query: {buscarPor: 'objeto'} }"><i class="fas fa-cubes" /> OBJETOS</router-link>
				<router-link :to="{ name: 'resultadoColecao', query: {buscarPor: 'colecao'}  }"><i class="fas fa-folder" /> COLEÇÕES</router-link>

				<div class="clean-filters" v-if="filtros.data">
					<button @click="clearFilter()" type="button">Limpar filtro <i class="far fa-times-circle" /></button>
				</div>

				<div class="filters">
					<filter-container title="Data de modificação">
						<Radio
							v-for="data in datas" :key="data.id" :value="data" :name="data.nome"
							@change="() => changeTipoDeObjeto(data)" :checked="fillTipoDeObjeto(data)" />
					</filter-container>
				</div>

			</div>

			<div class="objects" v-if="totalDeColecoes > 0">
				<colecao v-for="colecao in colecoes" :key="colecao.id" :colecao="colecao" />
			</div>
			<div v-else class="result">
				<p>0 coleções encontradas!</p>
			</div>
		</div>
		<div class="paginacao" v-if="totalDeColecoes > 20">
			<Pagination :totalItens="totalDeColecoes" :currentPage="currentPage" @pagina="buscarOjetos" />
		</div>
	</div>
</template>

<script>
import { colecoes } from '@/services/colecoes'

import EventBus from '@/components/event-bus'
import * as moment from 'moment-timezone'
import Pagination from '@/components/shared/Pagination'
import FilterContainer from '../shared/FilterContainer'
import Colecao from './BoxColecao'
import Radio from '../shared/Radio'

export default {
	name: 'ObjectResult',
	components: { FilterContainer, Radio, Colecao, Pagination },
	data () {
		return {
			colecoes: [],
			currentPage: 1,
			filtros: {
				texto: '',
				data: '',
				onlyRoot: true
			},
			datas: [
				{
					id: 1,
					label: 'Último ano',
					nome: moment().subtract(365, 'days').format('YYYY-MM-DD')
				},
				{
					id: 2,
					label: 'Último mês',
					nome: moment().subtract(30, 'days').format('YYYY-MM-DD')
				},
				{
					id: 3,
					label: 'Última semana',
					nome: moment().subtract(7, 'days').format('YYYY-MM-DD')
				},
				{
					id: 4,
					label: 'Ultimo dia',
					nome: moment().subtract(1, 'days').format('YYYY-MM-DD')
				}

			],
			totalDeColecoes: 0
		}
	},
	watch: {
		'$route.query': function () {
			this.obterFiltros()
			this.buscarOjetos()
		}
	},
	methods: {
		clearFilter () {
			this.filtros.data = ''
			return this.$router.push({
				name: 'resultadoColecao',
				query: {
					...this.filtros,
					data: '',
					buscarPor: this.$route.query.buscarPor
				}
			})
		},
		changeTipoDeObjeto (data) {
			const exists = this.datas.some(value => value.nome === data.nome)

			if (exists) this.filtros.data = data.nome
			else this.filtros.data.push(data.nome)

			return this.$router.push({
				name: 'resultadoColecao',
				query: {
					...this.filtros,
					data: data.nome.toString(),
					buscarPor: this.$route.query.buscarPor
				}
			})
		},
		fillTipoDeObjeto (data) {
			const isChecked = this.filtros.data === data.nome
			if (isChecked) return true
			return false
		},
		async obterFiltros (params = this.$route.query) {
			this.filtros.texto = params.texto
			this.filtros.data = params.data
		},
		async buscarOjetos (params = this.filtros) {
			EventBus.$emit('closeLoader', true)

			this.filtros.skip = this.$route.query.skip
			if (this.filtros && this.filtros.skip) {
				this.currentPage = parseInt(this.filtros.skip)
				this.filtros.skip = this.filtros.skip > 0 ? parseInt(this.filtros.skip) - 1 : this.filtros.skip
			} else {
				this.filtros.skip = 0
			}

			await colecoes.find(params)
				.then(res => {
					this.colecoes = res.data

					if (this.colecoes.length > 0) this.totalDeColecoes = this.colecoes[0].total
					else this.totalDeColecoes = 0
				})
				.catch(err => console.log(err))

			EventBus.$emit('closeLoader', false)
		}
	},
	async created () {
		EventBus.$emit('buscarPor', this.$route.query.buscarPor)
		await this.obterFiltros()
		await this.buscarOjetos()
	}
}
</script>

<style lang="scss" scoped>
.result-object {
	.page-title {
		color: #59708f;
		text-align: right;
		font-size: 4.2em;
		font-weight: 700;
		font-style: italic;
		text-transform: uppercase;
		margin: 40px 0;
	}

	.search-infos {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #fff;
		margin: 60px 0 0;
		padding: 0 0 6px;
		color: #fff;

		p {
			font-size: 1.2em;

			strong {
				font-weight: 700;
			}
		}
	}

	.search-result {
		display: grid;
		grid-template-columns: 320px auto;
		grid-gap: 0 60px;
		margin: 20px 0 0;
		color: #fff;

		.filters {
			display: flex;
			flex-direction: column;

			a {
				display: flex;
				align-items: center;
				justify-content: center;
				font-weight: 700;
				text-decoration: none;
				margin-bottom: 12px;
				height: 46px;
				color: #fff;
				border-radius: 5px;
				background-color: $dark-blue;
				border: 1px solid #fff;
				transition: .3s ease;

				&:hover {
					background-color: $second-color;
					border: none;
				}

				&.hover, &.active {
					background-color: $second-color;
					border: none;
				}

				i {
					font-size: 1.7em;
					margin-right: 14px;
				}
			}

			.clean-filters {
				text-align: right;
				margin: 20px 0;

				button {
					background: transparent;
					color: #fff;
					cursor: pointer;
					border: none;
					outline: none;

					i {
						margin-left: 10px;
					}
				}
			}
		}
		.result {
			font-size: 1.7em;
			display: flex;
			justify-content: center;
			margin-top: 40px;
		}
	}
	.paginacao {
		margin-top: 50px;
	}
}
</style>
